import {computed, inject, Injectable, signal} from '@angular/core';
import {firstValueFrom} from 'rxjs';
import {OnboardStatusDto} from '@app/areas/auth/models/auth-onboarding.dto';
import {UserOnboardingApiService} from '@app/areas/account/onboarding/services/user-onboarding-api.service';

@Injectable({
  providedIn: 'root',
})
export class UserOnboardingService {
  readonly status$ = signal<OnboardStatusDto | null>(null);
  readonly loading$ = signal(false);
  readonly currentFlow$ = computed(() => this.status$()?.currentFlow ?? null);
  readonly requiresOnboarding$ = computed(() => {
    const status = this.status$();

    if (!status) {
      return true;
    }

    if (status.enquiryComplete) {
      return false;
    }

    return !!status.consentRequired?.length || !!status.currentFlow;
  });
  readonly complete$ = computed(() => !this.requiresOnboarding$());
  readonly hasIncomplete$ = this.requiresOnboarding$;

  private api = inject(UserOnboardingApiService);

  async refresh(): Promise<OnboardStatusDto | null> {
    this.loading$.set(true);

    try {
      const status = await firstValueFrom(this.api.getStatus());
      this.status$.set(status ?? null);
      return status ?? null;
    } catch {
      this.status$.set(null);
      return null;
    } finally {
      this.loading$.set(false);
    }
  }
}
